export default "/_next/static/images/factory-a0ac31498b728d8b369ee22f41358b07.svg";